import * as THREE from 'three'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import * as SmoothScroll from 'smooth-scroll'

gsap.registerPlugin(ScrollTrigger)

export default function firstview() {

  let timer = 0;
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
  const renderer = new THREE.WebGLRenderer({ alpha: true }); // 背景を透明に設定
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.getElementById('firstview').appendChild(renderer.domElement);
  
  // フォグの追加
  const fogColor = 0x212121; // フォグの色
  const fogNear = 1;
  const fogFar = 125;
  scene.fog = new THREE.Fog(fogColor, fogNear, fogFar);
  
  // ライトの追加
  const ambientLight = new THREE.AmbientLight(0x404040); // soft white light
  scene.add(ambientLight);
  
  const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
  directionalLight.position.set(0, 1, 1).normalize();
  scene.add(directionalLight);
  
  const pointLight = new THREE.PointLight(0xffffff, 1, 100);
  pointLight.position.set(0, 0, 50);
  scene.add(pointLight);

  
  // 三角錐のジオメトリ作成
  const radius = 4;
  const height = 4;
  const radialSegments = 3;
  
  const pyramidGeometry = new THREE.ConeGeometry(radius, height, radialSegments);
  pyramidGeometry.rotateY(Math.PI / 3); // 一辺を上に持ってくる
  
  // 三角錐のマテリアル作成
  const materials = [
    new THREE.MeshStandardMaterial({ color: 0x0097b2, metalness: .1, roughness: 0.4 }), // 金属光沢の黄色
    new THREE.MeshStandardMaterial({ color: 0x0097b2, metalness: .2, roughness: 0.8 }), // 金属光沢のダークグレー
    new THREE.MeshStandardMaterial({ color: 0x212121, metalness: 1, roughness: 1 }), // 金属光沢のダークグレー
    new THREE.MeshStandardMaterial({ color: 0x212121, metalness: 1, roughness: 1 })  // 金属光沢のダークグレー
  ];
  
  // 三角錐のメッシュ作成
  function createPyramid() {
    const pyramidMaterial = new THREE.MeshFaceMaterial(materials);
    const pyramid = new THREE.Mesh(pyramidGeometry, pyramidMaterial);
    return pyramid;
  }
  
  // 三角錐のグループ作成
  const pyramidGroup = new THREE.Group();
  scene.add(pyramidGroup);
  
  // 三角錐を中央に配置し、2秒かけてランダムな位置に移動
  const pyramids = [];
  for (let i = 0; i < 128; i++) {
    const pyramid = createPyramid();
    pyramid.position.set(0, 0, 0);
    pyramid.rotation.set(Math.random() * 2 * Math.PI, Math.random() * 2 * Math.PI, Math.random() * 2 * Math.PI);
    pyramids.push(pyramid);
    pyramidGroup.add(pyramid);
  }
  
  // カメラ位置設定
  camera.position.z = 75;
  
  // アニメーション関数
  function animate() {
    requestAnimationFrame(animate);
  
    // 全ての三角錐を回転させる
    pyramidGroup.children.forEach(child => {
      if (child instanceof THREE.Mesh) {
        child.rotation.x += 0.02;
        child.rotation.y += 0.02;
        child.rotation.z += 0.02;
      }
    });
  
    timer += 0.001;
    const scale = 1 + 0.25 * Math.sin(timer);
    pyramidGroup.scale.set(scale, scale, scale);
  
    camera.rotation.z += 0.005;
    renderer.render(scene, camera);
  }
  
  // 初期配置からランダムな位置に移動するアニメーション
  pyramids.forEach(pyramid => {
    const targetX = (Math.random() - 0.5) * 300;
    const targetY = (Math.random() - 0.5) * 300;
    const targetZ = (Math.random() - 0.5) * 100 - 10;
    gsap.to(pyramid.position, {
      x: targetX,
      y: targetY,
      z: targetZ,
      duration: 2,
      ease: 'power1.out'
    });
  });
  
  animate();
  
  // ウィンドウリサイズ対応
  window.addEventListener('resize', () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    renderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  });
  
  gsap.fromTo(pyramidGroup.position,
    {
      z: 0,
    },
    {
      z: 150,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=300%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

  
  gsap.fromTo('#firstview .firstview__video img',
    {},
    {
      scale: 1.2,
      scrollTrigger: {
        trigger: '#app',
        start: "top top",
        end: "top top-=300%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

    
  gsap.fromTo('#firstview .firstview__video img',
    {},
    {
      opacity: 0,
      scrollTrigger: {
        trigger: '.audition-content',
        start: "top bottom",
        end: "top bottom-=50%",
        scrub: 1,
        once: false,
        //markers: true,
        invalidateOnRefresh: true,
      }
    }
  )

}
